var FoldersDocuments = {
    STATUS: {
        REQUIRED: 0, // Manquant
        UPLOAD: 1,   // Document chargé. En cours d'étude
        REJECTED: 2, // Document rejeté
        VALIDATE: 3  // Document validé
    }
};
